import React from "react";
import { SideMenu, Model,DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { MdGroups, MdAttachFile } from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import ProfileImage from "./../../../assets/images/ProfileImage.png";
import { BsEmojiSmileFill } from "react-icons/bs";
import { IoSend } from "react-icons/io5";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import { FiImage } from "react-icons/fi";
import { useAlert } from "react-alert";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
const Input = styled("input")({
  display: "none",
});
const Chat = () => {
  const alert = useAlert();
  const [selectedUser, setSelectedUser] = React.useState(0);
  const [addNewGroup, setAddNewGroup] = React.useState(false);
  const [addNewGroup2, setAddNewGroup2] = React.useState(false);
  const UsersList = [
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: true,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: true,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: false,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: true,
    },

    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: true,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: false,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: true,
    },
    {
      name: "Samantha aryton",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      active: false,
    },
  ];

  const ChatDetails = [
    {
      date: "JAN 4, 2022",
      chat: [
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Donec enim lectus, venenatis nec aliquam a, varius sed ex. Ut laoreet augue velit, vel malesuada elit euismod ut. Nam at dui eros. Vivamus sem quam, tincidunt a urna congue, malesuada consectetur leo. Donec ornare consectetur ante, ac viverra arcu rhoncus ac",
        },
      ],
    },
    {
      date: "JAN 5, 2022",
      chat: [
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Fusce ipsum ligula, convallis id venenatis in, accumsan eu augue.",
        },
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Mauris viverra vulputate justo nec tempor. Morbi varius dui sit amet mauris scelerisque blandit.",
        },
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Donec enim lectus, venenatis nec aliquam a, varius sed ex. Ut laoreet augue velit, vel malesuada elit euismod ut. Nam at dui eros. Vivamus sem quam, tincidunt a urna congue, malesuada consectetur leo. Donec ornare consectetur ante, ac viverra arcu rhoncus ac",
        },
      ],
    },
    {
      date: "JAN 4, 2022",
      chat: [
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Donec enim lectus, venenatis nec aliquam a, varius sed ex. Ut laoreet augue velit, vel malesuada elit euismod ut. Nam at dui eros. Vivamus sem quam, tincidunt a urna congue, malesuada consectetur leo. Donec ornare consectetur ante, ac viverra arcu rhoncus ac",
        },
      ],
    },
    {
      date: "JAN 5, 2022",
      chat: [
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Fusce ipsum ligula, convallis id venenatis in, accumsan eu augue.",
        },
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Mauris viverra vulputate justo nec tempor. Morbi varius dui sit amet mauris scelerisque blandit.",
        },
        {
          name: "Samantha aryton",
          time: "9:33 pm",
          message:
            "Donec enim lectus, venenatis nec aliquam a, varius sed ex. Ut laoreet augue velit, vel malesuada elit euismod ut. Nam at dui eros. Vivamus sem quam, tincidunt a urna congue, malesuada consectetur leo. Donec ornare consectetur ante, ac viverra arcu rhoncus ac",
        },
      ],
    },
  ];
  const AddNewGroupList = [
    {
      name: "Samantha aryton",
    },
    {
      name: "Johan smith",
    },
    {
      name: "Nataliya law",
    },
    {
      name: "Jezing",
    },
    {
      name: "Nataliya law",
    },
    {
      name: "Jezing",
    },
  ];

  // Add New Group
  const [addNewGroupLoading, setAddNewGroupLoading] = React.useState(false);
  const AddNewGroupHandler = () => {
    setAddNewGroupLoading(true);
    setTimeout(() => {
      setAddNewGroup(false);
      setAddNewGroup2(true);
      setAddNewGroupLoading(false);
    }, 2000);
  };

  // Create Group
  const [createGroupTitle, setCreateGroupTitle] = React.useState("");
  const [createGroupLoading, setCreateGroupLoading] = React.useState(false);
  const createGroupTitleRef = React.useRef();
  const CreateGroupHandler = () => {
    if (createGroupTitle === "") {
      alert.error(
        <div className="alert-message">please add your group title</div>
      );
      createGroupTitleRef.current.focus();
    } else {
      setCreateGroupLoading(true);
      const CreateGroupObject = {
        title: createGroupTitle,
      };
      alert.success(
        <div className="alert-message">you have successfully created</div>
      );
      console.log(CreateGroupObject);
      setTimeout(() => {
        setAddNewGroup2(false);
        setCreateGroupLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu chat={true}>
      <div className="chat-main">
        <Box>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>

        <div className="chat-box-main">
          <Grid container spacing={0}>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="chat-box-list-main">
                <div className="chat-box-list-header-main">
                  <p className="chat-box-list-header-heading">Chat inbox</p>
                  <Button onClick={() => setAddNewGroup(true)}>
                    <MdGroups color="#663399" size={20} />
                    <p className="chat-box-list-header-new-group">New Group</p>
                  </Button>
                </div>
                <div className="chat-box-search-main">
                  <BiSearch />
                  <input
                    type="text"
                    className="chat-box-search-input"
                    placeholder="Search name"
                  />
                </div>
                <div className="chat-box-all-users-list">
                  {UsersList.map((usersListValue, usersListIndex) => {
                    return (
                      <Button
                        key={usersListIndex}
                        onClick={() => setSelectedUser(usersListIndex)}
                        className={
                          selectedUser === usersListIndex
                            ? "chat-box-selected-user"
                            : "chat-box-un-selected-user"
                        }
                      >
                        <div>
                          <img
                            src={ProfileImage}
                            className="chat-box-all-users-profile-image"
                          />
                          {usersListValue.active && (
                            <div className="chat-box-active-user" />
                          )}
                        </div>
                        <div className="chat-box-all-users-message">
                          <p className="chat-box-all-users-username">
                            {usersListValue.name}
                          </p>
                          <p className="chat-box-all-users-message">
                            {usersListValue.message}
                          </p>
                        </div>
                      </Button>
                    );
                  })}
                </div>
              </div>
            </Grid>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <div className="chat-detail-main">
                <div className="chat-box-list-header-main">
                  <div className="chat-detail-header-main">
                    <img
                      src={ProfileImage}
                      className="chat-detail-user-profile-image"
                    />
                    <div>
                      <p className="chat-detail-header-user-name">
                        Samantha aryton
                      </p>
                      <div className="chat-detail-header-status-main">
                        <div className="chat-detail-header-active" />
                        <p className="chat-detail-header-status-title">
                          Available now
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-section-container">
                  {ChatDetails.map((chatDetailsValue, chatDetailsIndex) => {
                    return (
                      <div key={chatDetailsIndex}>
                        <div className="chat-section-date-main">
                          <div className="chat-section-date-line" />
                          <p className="chat-section-date">
                            {chatDetailsValue.date}
                          </p>
                          <div className="chat-section-date-line" />
                        </div>
                        {chatDetailsValue.chat.map((chatValue, chatIndex) => {
                          return (
                            <div key={chatIndex} className="chat-section">
                              <img
                                src={ProfileImage}
                                className="chat-detail-user-profile-image"
                              />
                              <div>
                                <div className="chat-section-user-name-main">
                                  <p className="chat-section-user-name">
                                    {chatValue.name}
                                  </p>
                                  <p className="chat-section-message-time">
                                    {chatValue.time}
                                  </p>
                                </div>
                                <p className="chat-section-message">
                                  {chatValue.message}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
                <div className="chat-type-container">
                  <div className="chat-type-input-main">
                    <input
                      type="text"
                      placeholder="Write a message..."
                      className="chat-type-input"
                    />
                  </div>
                  <div>
                    <label htmlFor="icon-button-file">
                      <Input
                        accept="image/*"
                        id="icon-button-file"
                        type="file"
                      />
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        className="icon-button-file chat-emoji-button"
                      >
                        <BsEmojiSmileFill color="#E0E0E0" />
                      </IconButton>
                    </label>
                    <label htmlFor="icon-button-file">
                      <Input
                        accept="image/*"
                        id="icon-button-file"
                        type="file"
                      />
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        className="icon-button-file chat-emoji-button"
                      >
                        <MdAttachFile color="#E0E0E0" />
                      </IconButton>
                    </label>
                    <Button className="send-message-button">
                      <IoSend color="white" size={25} />
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <Model
        modelTitle="Add New Group"
        width="md"
        onClose={() => setAddNewGroup(false)}
        open={addNewGroup}
        buttonTitle="Next"
        buttonHandler={AddNewGroupHandler}
        loading={addNewGroupLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  {AddNewGroupList.map((newGroupValue, newGroupIndex) => {
                    return (
                      <div key={newGroupIndex} className="chat-group-container">
                        <Checkbox
                          {...label}
                          defaultChecked
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                        />
                        <img
                          src={ProfileImage}
                          className="chat-detail-user-profile-image"
                        />
                        <p className="chat-group-username">
                          {newGroupValue.name}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      <Model
        modelTitle="Add New Group"
        width="md"
        onClose={() => setAddNewGroup2(false)}
        open={addNewGroup2}
        buttonTitle="Create"
        buttonHandler={CreateGroupHandler}
        loading={createGroupLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <div className="chat-group-title-main">
                    <label htmlFor="icon-button-file">
                      <Input
                        accept="image/*"
                        id="icon-button-file"
                        type="file"
                      />
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        className="icon-button-file chat-group-profile-upload"
                      >
                        <FiImage color="#BBBBBB" />
                      </IconButton>
                    </label>
                    <input
                      type="text"
                      name="title"
                      className="input"
                      placeholder="Your Group title"
                      value={createGroupTitle}
                      ref={createGroupTitleRef}
                      onChange={(e) => setCreateGroupTitle(e.target.value)}
                    />
                  </div>
                  {AddNewGroupList.map((newGroupValue, newGroupIndex) => {
                    return (
                      <div key={newGroupIndex} className="chat-group-container">
                        <div style={{ marginRight: "10px" }}>
                          <CloseIcon />
                        </div>
                        <img
                          src={ProfileImage}
                          className="chat-detail-user-profile-image"
                        />
                        <p className="chat-group-username">
                          {newGroupValue.name}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default Chat;
